export function buildQuery(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    q.set(key, String(value));
  });
  const qs = q.toString();
  return qs ? `?${qs}` : '';
}

export function parseErrorMessage(data, fallback) {
  if (!data) return fallback;
  if (data.error) {
    if (Array.isArray(data.error.message)) return data.error.message.join(', ');
    if (data.error.message) return data.error.message;
    if (Array.isArray(data.error.details)) {
      return data.error.details
        .map((d) => (typeof d === 'string' ? d : d?.message))
        .filter(Boolean)
        .join(', ');
    }
  }
  if (Array.isArray(data.message)) return data.message.join(', ');
  if (data.message) return data.message;
  return fallback;
}

/** Unwrap backend `{ data, meta? }` success envelope. */
export function unwrapData(body) {
  if (!body || typeof body !== 'object') return body;
  if (!Object.prototype.hasOwnProperty.call(body, 'data')) return body;

  const { data, meta } = body;
  if (meta === undefined) return data;
  if (data !== null && typeof data === 'object' && !Array.isArray(data)) {
    return { ...data, meta };
  }
  return { data, meta };
}

export async function handleResponse(res) {
  if (!res.ok) {
    let message = res.statusText || 'Request failed';
    let code;
    try {
      const data = await res.json();
      message = parseErrorMessage(data, message);
      code = data?.error?.code;
    } catch {
      /* ignore */
    }
    const error = new Error(message);
    error.status = res.status;
    error.name = 'ApiError';
    if (code) error.code = code;
    throw error;
  }

  if (res.status === 204) return undefined;
  const body = await res.json();
  return unwrapData(body);
}
